export default __webpack_public_path__ + "static/e-commerce-65eb928500d6ea092ceecb5f50347bf4.png";